var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 17,
    height: 17,
    viewBox: "14.125 16.19 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.625,
    cy: 24.69,
    r: 8.5,
    fill: "#e8e4da"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M24.079 19.936c0 .776-.547 1.323-1.311 1.323s-1.31-.547-1.31-1.323c0-.764.547-1.31 1.31-1.31.764.001 1.311.547 1.311 1.31m-2.561 9.986v-7.756h2.476v7.756z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationLight);
export default __webpack_public_path__ + "static/media/information-light.5e66cd820116977f1cbf2caf1efc6ee0.svg";
export { ForwardRef as ReactComponent };